import {
  GetProjectGroupPath,
} from '../Util/PathHelper';

export const HandleRouteToProjectGroup = (props, projectId, projectGroupId, openInNewTab) => {
  const uri = GetProjectGroupPath(projectId, projectGroupId);
  if (openInNewTab) {
    window.open(uri, "n1_projectGroupContent")
  } else {
    props.history.push(uri, { ...props.location.state });  
  }
}